import {action, makeObservable, observable} from "mobx";
import {ISoundUserPreferences} from "./user-sound-preferences.interface";

export class SoundUserPreferences implements ISoundUserPreferences {
    @observable.ref
    isMuted: boolean = true;

    @action.bound
    setIsMuted(v: boolean) {
        this.isMuted = v;
    }

    @action.bound
    toggle() {
        this.isMuted = !this.isMuted;
    }

    constructor() {
        makeObservable(this);
    }
}
